import { toAbsolute, normalize } from "./urls";

// A breadcrumb entry consists of a display name and a (possibly relative) URL
export type BreadcrumbEntry = [name: string, url: string];

/**
 * Builds a structured JSON-LD BreadcrumbList (schema.org format) from a list of entries.
 */
export function buildBreadcrumbList(entries: BreadcrumbEntry[], origin: string) {
    // Deduplicate entries by normalized URL, while preserving order of first occurrences
    const seen = new Set<string>(), filtered: BreadcrumbEntry[] = [];
    for (const [name, url] of entries) {
        // Normalize URL to compare consistently
        const key = normalize(url, origin); 

        // Only keep the first occurrence of each normalized URL
        if (!seen.has(key)) {              
            seen.add(key);
            // Keep original [name, url] for later processing
            filtered.push([name, url]);     
        }
    }

    // Convert filtered entries into schema.org "ListItem" objects
    const itemListElement = filtered.map(([name, url], i) => ({
        "@type": "ListItem",
        position: i + 1,                     // Position in breadcrumb trail (1-based)
        item: {
            "@id": toAbsolute(url, origin),  // Convert to absolute URL for schema.org requirement
            name                             // Display name of the breadcrumb item
        }
    }));

    // Return the final JSON-LD BreadcrumbList structure
    return {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement
    };
}
